
import ProductCardDefault from '@/components/ProductCard/ProductCardDefault.vue';

export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    stitle: {
      required: false,
      type: String,
    },
    items: {
      required: true,
      type: Array,
    },
    textCenter: {
      required: false,
      type: Boolean,
    },
    categoryLink: {
      default: '',
      type: String,
    },
    categoryLinkProduct: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      responsiveSlider: {
        0: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      val: false,
    };
  },
  computed: {},
  methods: {
    getCategorySeo(product) {
      if (product.Category) {
        const seoCat = product?.Category?.Main?.SEO;
        if (!seoCat) {
          return null;
        }
        try {
          if (Array.isArray(seoCat)) {
            let seo = seoCat[0];
            if (this.$i18n.locale === 'en') {
              seo = seoCat[1];
            }
            if (this.$i18n.locale === 'de') {
              seo = seoCat[2];
            }
            return seo;
          }
          return seoCat;
        } catch (error) {}
      }

      return null;
    },
    categoryId(product) {
      try {
        return '-' + product.Category.Main.IdCategory;
      } catch (error) {}

      return '-';
    },
    getCategoryLink(product) {
      try {
        const categorySeo = this.getCategorySeo(product);
        if (categorySeo && categorySeo.URL) {
          return categorySeo.URL + this.categoryId(product);
        }
      } catch (error) {}

      return 'product';
    },
  },
  mounted() {},
  components: { ProductCardDefault },
};
